<template>
  <DashboardPage>
    <LotDetail :id="route.params.id" />
  </DashboardPage>
</template>
    
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import LotDetail from './components/LotDetail.vue';
  
const route = useRoute()
</script>